import { openModal } from 'modal'
import SubscribeModal from './SubscribeModal'
export const openSubscribeModal = () => openModal(SubscribeModal)
